module.exports = __webpack_public_path__ + "static/media/new-mail.134dafab.svg";